import React, { useState } from 'react'

import { useTranslation } from 'react-i18next'

import { formatAmount } from 'ziphy-web-shared/basic/helpers'
import { Button } from 'ziphy-web-shared/basic/lib/buttons'
import { Checkbox } from 'ziphy-web-shared/basic/lib/simple'
import { Modal, ModalToolbarBtn } from 'ziphy-web-shared/basic/lib/utilities/modals'

import styles from './SelectPractice.modal.module.scss'

const SelectPracticeModal = ({ _core, practices, onSelect }) => {
  const { t } = useTranslation()
  const [selected, setSelected] = useState(null)

  const handleClick = () => {
    onSelect(selected)
    _core.onHide()
  }

  return (
    <Modal scrollable centered _core={_core}>
      <div className="modal-toolbar">
        <ModalToolbarBtn type="close" action={_core.onHide} />
      </div>
      <Modal.Header>
        <div className="title-md mb-0">{t('book.select_practice')}</div>
      </Modal.Header>
      <Modal.Body>
        {practices.map(
          (item) => (
            <div className={styles.wrapper} key={item.practiceId}>
              <div className={styles.body} onClick={() => setSelected(item.practiceId)}>
                <Checkbox
                  className={styles.checkbox}
                  isChecked={selected === item.practiceId}
                  mode={['round', 'dark']}
                />
                <div className={styles.content}>
                  <div className={styles.title}>
                    <div className={styles.titleText}>{item.practiceName}</div>
                    <div className={styles.titlePrice}>
                      {formatAmount(item.price, item.currency)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ),
          [],
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button mode={['primary', 'block']} disabled={selected === null} onClick={handleClick}>
          {t('btn.continue')}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default SelectPracticeModal
